import React from 'react';
import { Field } from 'redux-form';
import { TextInput } from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import Toolbar from '../StaticData/Toolbar';

const ValidateRequired = required();

const styles = createStyles({
  half_length: {
    width: '50%'
  }
});

type Props = {
  classes: any
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name="title" source="title" component={TextInput} label="Title *" validate={ValidateRequired} className={props.classes.half_length} /><br /><br />

    <Field name="content" source="content" component={RichTextInput} label="Content" toolbar={Toolbar} />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Documentations/Partials/SettingsTab.tsx